import React, { useCallback, useRef } from "react";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { Toast } from "primereact/toast";
import { PrimeIcons } from "primereact/api";
import ReportsConstants from "reports/utils/ReportsConstants";
import useContextMenuItems from "reports/data-export/data-export-list/hooks/useContextMenuItems";
import useToggleStatus from "reports/data-export/data-export-list/hooks/useToggleStatus";
import useDataExportUpdate from "reports/data-export/data-export-list/hooks/useDataExportUpdate";
import PrimeReactConstants from "core/app/util/PrimeReactConstants";

const { ACTIVE } = ReportsConstants;
const { RIGHT, SMALL } = PrimeReactConstants;
const { ELLIPSIS_V } = PrimeIcons;

const btnStyle = { padding: "0.5rem" };
const menuStyle = { width: "16rem" };

const ContextMenu = (rowData) => {
  const menuRef = useRef(null);
  const toastRef = useRef(null);
  const { id, reportStatus } = rowData;
  const isActive = reportStatus === ACTIVE;
  const { postData } = useDataExportUpdate();

  const toggleStatus = useToggleStatus({
    reportsList: [rowData],
    postData,
    toastRef,
  });

  const menuItems = useContextMenuItems({
    isActive,
    id,
    reportInfo: rowData,
    toggleStatus,
    toastRef,
  });

  const handleToggleMenu = useCallback((evt) => {
    menuRef.current.toggle(evt);
  }, []);

  return (
    <nav>
      <Toast ref={toastRef} />
      <Menu
        model={menuItems}
        popup
        popupAlignment={RIGHT}
        ref={menuRef}
        style={menuStyle}
      />
      <Button
        data-testid="data-export-list-context-menu"
        icon={ELLIPSIS_V}
        onClick={handleToggleMenu}
        size={SMALL}
        style={btnStyle}
        text
      />
    </nav>
  );
};

export default ContextMenu;
